import React, { useState } from 'react';
import useSWR from 'swr';
import _ from 'lodash';
import '@vibe/core/tokens';
import { useParams } from 'react-router';
import { ErrorBox } from '@gorilla/ui/src/components/ErrorBox';
import Luckysheet from '../../components/Luckysheet';
import { getSpreadsheet } from '../../services/spreadsheets';
import LoadingSpreadsheet from '../../components/LoadingSpreadsheet';
import ExperimentalSpreadsheetModal from '../../components/ExperimentalSpreadsheetModal';
import { mondayClient } from '../../services/monday';
import './RenderSpreadsheetPage.css';

function RenderSpreadsheetPage() {
  const params = useParams();

  const [showExperimentalModal, setShowExperimentalModal] = useState<boolean>(true);

  const {
    data: spreadsheet,
    error,
    mutate,
  } = useSWR(
    `/api/get-spreadsheet/${params.spreadsheetId}`,
    async () => {
      return (await getSpreadsheet(params.spreadsheetId!)).value;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
    },
  );

  if (error) {
    return <ErrorBox error={error} mondayClient={mondayClient} />;
  }

  return (
    <div className="Spreadsheet">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          width: '100%',
          height: '100%',
          minHeight: 'inherit',
        }}
      >
        {spreadsheet ? (
          <Luckysheet
            spreadsheetId={params.spreadsheetId}
            initialData={spreadsheet.data}
            title={spreadsheet.title}
            preview={false}
            onSave={() => {
              mutate();
            }}
          />
        ) : (
          <LoadingSpreadsheet />
        )}
      </div>

      {spreadsheet && showExperimentalModal ? (
        <ExperimentalSpreadsheetModal
          show={showExperimentalModal}
          onClose={() => {
            setShowExperimentalModal(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default RenderSpreadsheetPage;
